import { useAtomCallback } from 'jotai/utils';
import { useCallback, useEffect, useState } from 'react';
import ChatCache from '../../modules/home/v1/states/cache';

export const useLoadChatCache = () => {
  const [loading, setLoading] = useState(true);

  const createChatCache = useAtomCallback(
    useCallback((get, set) => {
      return ChatCache.getInstance(get, set);
    }, [])
  );

  const loadChatCache = useCallback(async () => {
    try {
      const chatCache = await createChatCache();
      setLoading(false);
      return chatCache;
    } catch (error) {
      // Important: don't keep the UI stuck on the loading screen forever.
      // If cache init fails, the rest of the UI should be able to render and surface errors.
      // eslint-disable-next-line no-console
      console.error('Failed to initialize ChatCache', error);
      setLoading(false);
    }
  }, [createChatCache]);

  useEffect(() => {
    loadChatCache();
  }, [loadChatCache]);

  return loading;
};
